export const ADMIN = "ape-admin";
export const CUSTOMER = "ape-customer";
export const DEFAULT = "ape-default";
